import React, {useContext} from 'react';
import { NavigateWayContext } from '../../store/NavigateWayContext';
import { useNavigate, useLocation } from "react-router-dom";
import './Breadcrumb.css';


const Breadcrumb = (props) => {
    const navigate = useNavigate();
    const location = useLocation()
    const { navigateWay } = useContext(NavigateWayContext);
    // navigateWay = {site: '/dc', room: '', map: '', newcount: '', diagram: ''}
        
    return (
        <div className='breadcrumb-container'>
            <h2>
                <p onClick={() => navigate(navigateWay.site)}
                    style={
                        props.site == false ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }    
                >
                    Data Centers
                </p>

                {
                    props.site ?
                    <p> / </p>
                    : ""
                }
                
                <p onClick={() => navigate(navigateWay.room)}
                    style={
                        props.site && 
                        props.room == false ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }    
                >
                    {props.site ?
                        navigateWay.room.split('/')[2]
                        : ""
                    }
                </p>

                {
                    props.room ?
                    <p> / </p>
                    : ""
                }

                <p onClick={() => navigate(navigateWay.rack)}
                    style={
                        props.room && 
                        props.map == false && 
                        props.newcount == false && 
                        props.diagram == false ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }     
                >
                    {props.room ?
                        navigateWay.rack.split('/')[3]
                        : ""
                    }
                </p>

                {
                    props.map ?
                    <p> / </p>
                    : ""
                }

                <p onClick={() => navigate(navigateWay.map, {state: location.state})}
                    style={
                        props.room && 
                        props.map && 
                        props.newcount == false && 
                        props.diagram == false ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }   
                >
                    {props.map ?
                        "Rack Count History"
                        : ""
                    }
                </p>

                {
                    props.newcount || props.diagram ?
                    <p> / </p>
                    : ""
                }

                <p style={
                        props.room && 
                        props.map && 
                        props.newcount == true && 
                        props.diagram == false ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }>
                    {props.newcount ?
                        "New Rack Count"
                        : ""
                    }
                </p>

                <p style={
                        props.room && 
                        props.map == false && 
                        props.newcount == false && 
                        props.diagram == true ? 
                        {color: "#0F0742", fontWeight:"700"} : {}
                    }>
                    {props.diagram ?
                        "Room Map"
                        : ""
                    }
                </p>
                
            </h2>
        </div>
    )
}

export default Breadcrumb